import styled from 'styled-components';

export const Wrap = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  padding: 18px 20px 8px;
`;

export const Col = styled.div`
  display: flex;
  flex-direction: column;
  width: 74px;
`;

export const ColLabel = styled.div`
  text-align: center;
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #7a838a;
  margin-bottom: 8px;
`;

export const ScrollList = styled.div`
  position: relative;
  height: 182px;
  overflow-y: auto;
  background: #10151a;
  border: 1px solid #2c353d;
  border-radius: 10px;
  padding: 71px 4px;
  scroll-behavior: smooth;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #3a444b;
    border-radius: 3px;
  }
`;

export const Opt = styled.div`
  padding: 7px 0;
  text-align: center;
  border-radius: 7px;
  font-size: 16px;
  font-family: 'IBM Plex Mono', monospace;
  font-variant-numeric: tabular-nums slashed-zero;
  color: #aab2b8;
  cursor: pointer;
  transition:
    background-color 0.12s ease,
    color 0.12s ease;
  &:hover {
    background: #1a2429;
    color: #e6eaec;
  }
  &.active {
    background: #47b972;
    color: #ffffff;
    font-weight: 600;
  }
`;
